import type { HowItWorksData } from '@/content/types';

export default function HowItWorks(props: HowItWorksData) {
  return (
    <section className="container section-padding">
      <div className="split-2col">
        <div>
          {props.eyebrow && <div style={{ fontSize: 14, color: 'var(--color-muted)' }}>{props.eyebrow}</div>}
          <h2 className="h-feature" style={{ marginTop: 12 }}>{props.title}</h2>
          <p style={{ marginTop: 16, color: 'var(--color-muted)' }}>{props.body}</p>
          <ol style={{ marginTop: 32, listStyle: 'none', padding: 0 }}>
            {props.steps.map((s, i) => (
              <li key={i} style={{ display: 'flex', gap: 16, marginBottom: 20 }}>
                <span style={{ flexShrink: 0, width: 32, height: 32, borderRadius: 16, background: 'var(--color-ink)', color: '#fff', display: 'grid', placeItems: 'center', fontWeight: 700 }}>{s.num}</span>
                <div>
                  <h4 style={{ fontWeight: 700 }}>{s.title}</h4>
                  <p style={{ color: 'var(--color-muted)' }}>{s.desc}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
        {props.image && <div><img src={props.image.src} alt={props.image.alt} width={props.image.width} height={props.image.height} loading="lazy" decoding="async" style={{ borderRadius: 16, width: '100%', height: 'auto' }} /></div>}
      </div>
    </section>
  );
}
